import React, { Component } from 'react'

import SearchIcon from '../../../../assets/icons/NavbarSearch.svg';

import './Search.css';

export default class Search extends Component {
  render() {
    return (
      <div className="search d-flex">
        <input type="search" placeholder="جستجو در شخص یا وظایف" />
        <img src={SearchIcon} alt="جستجو" />
      </div>
    );
  }
}